import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import intro299mobileMainBackground from './img/intro299mobile-mainbackground.jpg'
import intro299desktopMainBackground from './img/intro299desktop-mainbackground.jpg'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSimplifiedName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'já se casaram'
      : 'vão se casar'
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro299">
      <div className="intro299mobile screen">
        <img
          className="main-background-Zf8dVG"
          src={background || intro299mobileMainBackground}
        />
        <div className="container-center-horizontal">
          <div className="button-Zf8dVG">
            <div
              className="site-de-casamento-e-rPotg4"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-rPotg4" onClick={onSkipIntro}>
              <div className="button-tvy8Ou"></div>
              <div className="pular-introduo-tvy8Ou">{buttonMessage}</div>
            </button>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-Zf8dVG">
            <div className="container-center-horizontal">
              <div className="marry-mobile bp2-animate-enter">{text}</div>
            </div>
            <div className="container-center-horizontal">
              <div className="notranslate couple-name-4gefDN bp2-animate-enter1">
                {coupleSimplifiedName.bride}{' '}
                {coupleSimplifiedName.groom && (
                  <> &amp; {coupleSimplifiedName.groom}</>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="intro299desktop screen">
        <img
          className="main-background-080CGB"
          src={background || intro299desktopMainBackground}
        />
        <div className="container-center-horizontal">
          <div className="button-080CGB">
            <div
              className="site-de-casamento-e-FofmC4"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-FofmC4" onClick={onSkipIntro}>
              <div className="button-aRVgu9"></div>
              <div className="pular-introduo-aRVgu9">{buttonMessage}</div>
            </button>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-080CGB">
            <div className="marry">{text}</div>

            <div className="container-center-horizontal">
              <div className="notranslate couple-name-Oclyhl bp1-animate-enter1">
                {coupleSimplifiedName.bride}
                {coupleSimplifiedName.groom && (
                  <> &amp; {coupleSimplifiedName.groom}</>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
